export default __webpack_public_path__ + "static/media/tools.6db258a1.webp";